import { Div } from '../../../base/components/native/div'
import { ROUND, WH } from '../../../base/helpers/style'

export const Color = (id: string, code: string) => {

    const base = Div()
    base.el.onclick = () => base.emit('click', id)
    base.cssClass({
        ...WH(24),
        ...ROUND,
        margin: '10px',
        backgroundColor: code,
        cursor: 'pointer',
        '&:hover': {
            border: '2px solid #eee'
        }
    })

    return base
}